import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { LogoMark } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await api.post("/auth/login", { email, password }); nav("/admin"); }
    catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };
  const field = "w-full bg-transparent border border-white/25 px-4 py-4 focus:border-[#56ED4A] outline-none";
  return (
    <div className="grain min-h-screen grid place-items-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md border border-white/10 bg-[#121216] p-8 md:p-10 flex flex-col gap-4">
        <LogoMark className="w-20 h-20" />
        <h1 className="font-display uppercase text-5xl mt-4">Crew login</h1>
        <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={field} />
        <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={field} />
        {err && <p data-testid="admin-login-error" className="text-[#FF5A5A] text-sm">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="bg-[#56ED4A] text-black py-4 font-mono uppercase tracking-[0.2em] text-sm font-semibold flex justify-center gap-2 disabled:opacity-60">
          {busy && <Loader2 className="animate-spin" size={18} />} Enter
        </button>
        <Link to="/" data-testid="admin-login-back" className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-[#56ED4A]">← Back to site</Link>
      </form>
    </div>
  );
}
